<div
    class="pointer-events-none absolute inset-0 inline-flex items-center justify-center"
    style="z-index: 31000"
    [class.blurred-loader]="isLoading()">
    @if (isLoading()) {
        <app-icon class="text-orange animate-spin" icon="loading" size="extralarge"></app-icon>
    }
</div>
